module.exports = "/images/vendor/flag-icon-css/flags/1x1/mp.svg?8a731cbc2f690d74704a7da71addcbf3";